import React from 'react';
import { Icon } from '../../../components/BillingMDC';
import Switch from '../../../components/Switch';
import HorizontalLabelValueBar from '../../common/horizontalLabellValueBar';

const AgentBody = ({ dataList, onRowClick ,handleInputChange }) => (
  <tbody>
    {dataList.map((data, index) => (
      <tr>
        <td className='left-align'>{data.name}</td>
        <td className='left-align'>{data.phone}</td>
        <td className='text-center'>
          <div className='form-switchs '>
            <HorizontalLabelValueBar
              value={
                <Switch
                  onToggle={(checked, event) => handleInputChange('status', checked, data)}
                  checked={data.status}
                  id={`switch-${data.idAgent}`}
                  className='cursor-pointer '
                />
              }
            />
          </div>
        </td>
        <td className='right-align'>
          <Icon name='edit' onClick={() => onRowClick(data, index)} />
        </td>
      </tr>
    ))}
  </tbody>
);

const agentConfig = [
  {
    id: 1,
    label: 'name',
    title: 'Salesperson Name',
    className: 'cursor-pointer',
    sortable: false,
  },
  {
    id: 2,
    label: 'phone',
    title: 'Phone No.',
    className: 'cursor-pointer',
    sortable: false,
  },
  {
    id: 3,
    label: 'status',
    title: 'Status',
    className: 'cursor-pointer text-center',
    sortable: false,
  },
  {
    id: 4,
    label: '',
    title: '',
    className: 'cursor-pointer',
    sortable: false,
  },
];

const formValidationFieldList = [{ title: 'name' }, { title: 'phone' }];

const config = {
  header: agentConfig,
  getTableBody: AgentBody,
  formValidationFieldList,
};

export default config;
